import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Button from '@material-ui/core/Button';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';

import * as Actions from './redux-actions.js'
import * as helpers from './helpers.js'
import * as globals from './globals.js'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  offset: theme.mixins.toolbar,
}));


function TopNav(props) {
  const classes = useStyles();
  const authenticated = useSelector(state => state.authenticated)
  const current_user = useSelector(state => state.current_user)
  const dispatch = useDispatch()
  const serverStatus = useSelector(state => state.serverStatus)

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);


  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  var handleLogout = (e) => {
     helpers.getAPI(
         { func: (data, resp) => {
         	     if (data.status === "OK") {
                    dispatch({type: Actions.LOGOUT}) 
                  }          	    
            }, 
           uri: globals.myAPIurl+'/logout'
         })
        
  }  
  


  return (

  <div className={classes.root}>
      <AppBar position="fixed">
        <Toolbar>
          <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
            <MenuIcon onClick={props.onClick}/>
          </IconButton>
          <Typography variant="h6" className={classes.title}>
             {props.caption}
          </Typography>
          <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <AccountCircle />
          </IconButton>

            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={open}
                onClose={handleClose}
              >
                <MenuItem>{current_user}</MenuItem>
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu>


        </Toolbar>
      </AppBar>
      <div className={classes.offset} />
    </div>
  )

}

export default TopNav